import { Outlet } from 'react-router-dom';
import { RequireDashboardAuth } from '@/platform/auth/require-dashboard-auth';
import { AppShell } from '@/platform/layout/app-shell';

export function DashboardLayout() {
  return (
    <RequireDashboardAuth>
      <AppShell>
        <Outlet />
      </AppShell>
    </RequireDashboardAuth>
  );
}
